<template>

    <div class="dropdown" :class="{'is-active': isActive}" @mouseover="openDropDown" @mouseleave="closeDropDown">
        <div class="dropdown-trigger">
            <button class="button" aria-haspopup="true" aria-controls="dropdown-menu">
                <span><slot name="dropdownLabel" /></span>
                <span class="icon is-small">
                    <i class="zmdi zmdi-chevron-down" aria-hidden="true"></i>
                </span>
            </button>
        </div>
        <div class="dropdown-menu" id="dropdown-menu" role="menu">
            <div class="dropdown-content">
                <slot name="dropdownItems" />
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'DropDown',
    props: {

    },
    data(){
        return {
            isActive: false
        }
    },
    methods: {
        openDropDown(){
            this.isActive = true
        },
        closeDropDown(){
            this.isActive = false
        }
    }
}


</script>

<style lang="scss" >
.dropdown{
    .dropdown-trigger{
        button{
            border-color: $info;
        }
        .icon{
            width: 32px;
            i{
                color: $info;
                font-size: 2rem;
                // margin-top: -8px;
            }
        }
    }
    .dropdown-menu{
        border-radius: 2px;
        min-width: 100%;
        width: auto;
        .dropdown-content{
            border-radius: 2px;
            a{
                font-size: 1rem;
                color: $info;
                &:hover{
                    color: darken($info, 10%);
                }
            }
        }
    }
}
</style>